import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';
import { GooglesheetService } from 'src/app/services/googlesheet.service';
import { MensajeWhatsappService } from 'src/app/services/mensaje-whatsapp.service';
import { SeoService } from 'src/app/services/seo.service';
import { PREVIEW_CAMPAIGN } from 'src/app/shared/campaign-preview';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeComponent {
  readonly campanaPreview = PREVIEW_CAMPAIGN;
  data: any[] = [];
  titulo: string = 'Tu iPhone, al mejor precio en Olavarría';
  subtitulo: string = 'Nuevos y usados con garantía escrita. Tomamos tu iPhone actual como parte de pago.';
  texto: string = '';
  cargando: boolean = true;
  resenas: any[] = [];
  resenasInfo: { total: number; promedio: number } | null = null;
  @ViewChild('carrusel') carrusel?: ElementRef<HTMLDivElement>;
  private arrastrando = false;
  private inicioX = 0;
  private scrollInicio = 0;
  private intervaloResenas: ReturnType<typeof setInterval> | null = null;

  constructor(
    private sheetService: GooglesheetService,
    private mensajeWhatsappService: MensajeWhatsappService,
    private title: Title,
    private meta: Meta,
    private seo: SeoService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private plataforma: object,
  ) {}

  scrollPor(direccion: number): void {
    const el = this.carrusel?.nativeElement;
    if (!el) return;
    el.scrollBy({
      left: direccion * Math.max(260, el.clientWidth * 0.8),
      behavior: 'smooth',
    });
  }

  // Arrastre con mouse/trackpad. En touch se deja el scroll nativo.
  iniciarArrastre(e: PointerEvent): void {
    const el = this.carrusel?.nativeElement;
    if (!el || e.pointerType === 'touch') return;
    this.arrastrando = true;
    this.inicioX = e.clientX;
    this.scrollInicio = el.scrollLeft;
    el.setPointerCapture?.(e.pointerId);
  }

  moverArrastre(e: PointerEvent): void {
    const el = this.carrusel?.nativeElement;
    if (!el || !this.arrastrando) return;
    el.scrollLeft = this.scrollInicio - (e.clientX - this.inicioX);
  }

  soltarArrastre(): void {
    this.arrastrando = false;
  }

  // Loop infinito: se duplican las reseñas y al pasar la mitad del ancho se
  // salta al equivalente del otro lado (sin animación, para que no se note).
  get resenasLoop(): any[] {
    return this.resenas.length ? [...this.resenas, ...this.resenas] : [];
  }

  alScrollear(): void {
    const el = this.carrusel?.nativeElement;
    if (!el) return;
    const mitad = el.scrollWidth / 2;
    if (mitad > 0 && el.scrollLeft >= mitad) {
      el.scrollLeft -= mitad;
    }
  }

  pausarAuto(): void {
    if (this.intervaloResenas) {
      clearInterval(this.intervaloResenas);
      this.intervaloResenas = null;
    }
  }

  reanudarAuto(): void {
    if (this.intervaloResenas) return;
    if (!isPlatformBrowser(this.plataforma)) return;
    this.intervaloResenas = setInterval(() => {
      const el = this.carrusel?.nativeElement;
      if (!el || this.arrastrando || document.hidden) return;
      el.scrollBy({ left: 312, behavior: 'smooth' });
    }, 4000);
  }

  ngOnDestroy(): void {
    this.pausarAuto();
  }

  ngOnInit(): void {
    const titulo = 'iPhones nuevos y usados en Olavarría | SOY iPhone';
    const descripcion =
      'Compra y venta de iPhones nuevos y usados en Olavarría. Tomamos tu iPhone como parte de pago, envío a domicilio o retiro en San Lorenzo 2586.';
    this.title.setTitle(titulo);
    this.meta.updateTag({ name: 'description', content: descripcion });
    this.seo.setCanonicalUrl('/');
    this.seo.setSocial(titulo, descripcion);
    // Reseñas reales de Google: solo en el browser (el SSR muestra el bloque
    // estático) para no hacer un fetch relativo durante el render del server.
    if (isPlatformBrowser(this.plataforma)) {
      this.http.get<any>('/api/resenas').subscribe({
        next: (r) => {
          this.resenas = r?.resenas ?? [];
          this.resenasInfo = {
            total: r?.total ?? 0,
            promedio: r?.promedio ?? 0,
          };
          this.reanudarAuto();
        },
        error: () => {
          /* queda el bloque estático */
        },
      });
    }

    this.getDataFromSheet('Home', '!B1:B8', (data) => {
      this.titulo = data[0];
      this.subtitulo = data[1];
      this.texto = data[2];
    });
  }

  getDataFromSheet(
    seccion: string,
    rangos: string,
    callback: (data: any) => void,
  ) {
    this.sheetService.getSheetData(seccion + rangos, 'config').subscribe({
      next: (data) => {
        const values = data.values;
        callback(values); // Ejecutamos el callback con los valores obtenidos
      },
      error: (error) => {
        console.log(error);
        // Si falla la carga (p. ej. cuota de Sheets 429), igual hay que
        // sacar el skeleton: `complete` no se ejecuta en error.
        this.cargando = false;
      },
      complete: () => {
        this.cargando = false;
      },
    });
  }

  enviarWhatsApp() {
    this.mensajeWhatsappService.enviarWhatsApp();
  }
}
